import { render } from "./PCPopupGetDataForNewPale.vue?vue&type=template&id=68003afc&scoped=true"
import script from "./PCPopupGetDataForNewPale.vue?vue&type=script&lang=js"
export * from "./PCPopupGetDataForNewPale.vue?vue&type=script&lang=js"

import "./PCPopupGetDataForNewPale.vue?vue&type=style&index=0&id=68003afc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68003afc"]])

export default __exports__